import { BaseComponent } from '../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { HBox, VBox } from '../../../components/Box';
import { Button } from '../../../components/Buttons';
import { addAddress, deleteAddress, fetchCountries, updateAddress } from '../actions';
import { selectCountries, selectCompanyPropertyNames } from '../selectors';
import { selectAddressTypes } from '../../Address/selectors';
import { Checkbox } from '../../../components/Checkbox';
import { CompanyAddressModal } from './CompanyAddressModal';
import { parseCompany } from '../helpers';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import { makeSelectLocale } from '../../../containers/LanguageProvider/selectors';
import { translateCountry } from '../translate-countries';

const STATE = {
  edit: null,
  value: '',
  addCompanyAddress: false,
  addValue: '',
  deleteAddressConfirm: null,
  addCountryId: null,
  address: { countryId: null, typeId: 2 },
  fieldErrors: null,
  standardLocation: null,
  currentStandard: null,
};

const Container = styled.div`
  font-size: 14px;

  .cell:first-child {
    text-transform: capitalize;
  }
`;

const Address = styled.div`
  border: 1px solid rgb(21, 172, 121);
  border-radius: 6px;
  padding: 12px;
  width: 100%;
  margin: 6px 0;
  font-size: 12px;

  .button {
    margin: 0 -12px;
  }
  .name {
    font-size: 12px;
  }
  .address {
    margin-top: 12px;
  }
`;

/* eslint-disable react/prefer-stateless-function */
class CompanyAddressesComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.fetchCountries();
    const standardLocationId = this.props.company?.properties?.find(p => p?.name?.name === 'transport_location_id')?.value;
    this.setState({ standardLocation: standardLocationId });
  }

  editAddress(address) {
    this.setState({ edit: address.id, address });
  }

  reset() {
    this.setState({ ...STATE });
  }

  get company() {
    return this.props.company;
  }

  get address() {
    return this.props.address ?? {};
  }

  get countries() {
    return this.props.countries;
  }

  get addressTypes() {
    return this.props.addressTypes;
  }

  get locale() {
    return this.props.locale;
  }

  get isStandartLocation() {
    return parseCompany(this.props.company).properties.filter(prop => prop.name.name === 'transport_location_id')[0]?.value;
  }

  render() {
    const company = this.props.company;

    return (
      <Container>
        {!!this.state.addCompanyAddress && (
          <CompanyAddressModal
            companyId={this.props.company.id}
            standardId={this.state.standardLocation}
            address={this.state.address}
            isEdit={false}
            toggle={() => this.setState({ addCompanyAddress: false })}
          />
        )}
        <HBox vCenter>
          <h2>{this.lbl('company.details.addresses')}</h2>

          <ButtonComponent size="btn-sm" style="ButtonSoftPrimary" onClick={this.setStateFn({ addCompanyAddress: true })}>
            {this.lbl('add')}
          </ButtonComponent>
        </HBox>
        {!!this.countries?.length && !!this.addressTypes?.length && (
          <VBox>{company?.addresses?.map(a => this.renderAddress(a))}</VBox>
        )}
      </Container>
    );
  }

  renderAddress(address) {
    if (this.state.edit === address.id)
      return (
        <CompanyAddressModal
          companyId={this.props.company.id}
          standardId={this.state.standardLocation}
          isEdit={true}
          address={address}
          toggle={() => this.setState({ edit: null })}
        />
      );
    console.log('Adres: ', address);
    return (
      <Address key={`${address.id}`}>
        <VBox left>
          <HBox vCenter>
            <h3 className="name">{this.lbl(`address.type.${address.type?.name}`)}</h3>
            <FontAwesomeIcon role="button" icon={faEdit} onClick={() => this.editAddress(address)} />
          </HBox>
          {/*<div>{address.type?.name}</div>*/}

          {/*<div>{address.addressLine2}</div>*/}
          <VBox className="address" left>
            <div>{address.addressLine1}</div>
            <div>
              {address.postcode} {address.city}
            </div>
            <div>{translateCountry(address.country?.name, this.locale)}</div>
          </VBox>

          <VBox className="address" left>
            <strong>{this.lbl('company.details.comment')}</strong>
            {address.description}
          </VBox>
        </VBox>
      </Address>
    );
  }
}

CompanyAddressesComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    companyPropertyNames: selectCompanyPropertyNames(),
    countries: selectCountries(),
    addressTypes: selectAddressTypes(),
    locale: makeSelectLocale(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetchCountries() {
      dispatch(fetchCountries());
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyAddresses = compose(withConnect, withRouter, injectIntl)(CompanyAddressesComp);
